module.exports = __webpack_public_path__ + "static/media/elisadaniel.23e7bcb9.png";